module.exports = __webpack_public_path__ + "img/demand_on.9ec15a3c.svg";